const REGISTER = {
  intro_msg: 'Anfordern eines Zugangs für die VIACOR App.',
  success_msg: 'Ihre Anfrage wurde gesendet. Nach einer Prüfung bekommen Sie eine E-Mail mit der Bestätigung.',
};

export default REGISTER;
